module.exports = __webpack_public_path__ + "img/magnifying-glas-white.8a52512d.svg";